import * as moment from 'moment';
import { environment } from 'src/environments/environment';

export class Event {
  [key: string]: any;

  uuid_event: string | undefined;
  id_selector: string | undefined;
  name_selector: string | undefined;

  event_name: DescLang | undefined;
  event_name_it: string | undefined;
  event_name_en: string | undefined;
  event_name_de: string | undefined;
  event_name_fr: string | undefined;
  event_name_es: string | undefined;
  event_name_pt: string | undefined;

  event_short_description: DescLang | undefined;
  event_short_description_it: string | undefined;
  event_short_description_en: string | undefined;
  event_short_description_de: string | undefined;
  event_short_description_fr: string | undefined;
  event_short_description_es: string | undefined;
  event_short_description_pt: string | undefined;

  event_long_description: DescLang | undefined;
  event_long_description_it: string | undefined;
  event_long_description_en: string | undefined;
  event_long_description_de: string | undefined;
  event_long_description_fr: string | undefined;
  event_long_description_es: string | undefined;
  event_long_description_pt: string | undefined;

  fk_event_category: number | undefined;
  fk_ship: string | undefined;
  min_age_reservable: boolean | number | undefined;
  event_dates: Array<EventDate> | undefined;
  time_reservable_before_slot: number | undefined;
  end_time_reservable_before_slot: number | undefined;
  end_time_editable_before_slot: number | undefined;
  event_groups: Array<EventGroup> | undefined;
  event_occurrences: Array<EventOccurence> | undefined;
  max_per_passenger_reservable: boolean | number | undefined;
  event_opening_mode: string | undefined = undefined;
  // event_location?: string;
  max_users_wl: number | string | undefined;
  current_users_wl: number | string | undefined;
  waiting_list_end_time: number | undefined;

  global_id: string | undefined;

  constructor() {
    this.event_dates = new Array<EventDate>();
    this.event_groups = new Array<EventGroup>();
  }

  convertToBE(
    selectedTimeRelativeChiusura: TimeType,
    selectedTimeRelativeChiusuraWL: TimeType,
    selectedTimeTypeApertura: TimeType,
    selectedTimeTypeChiusura: TimeType,
    selectedTimeTypeChiusuraWL: TimeType,
    selectedMode: OpeningMode ) {
    let body: Event = new Event();
    if (this.uuid_event) body.uuid_event = this.uuid_event;
    body.event_opening_mode = selectedMode;
    body.event_name = this.event_name;
    body.fk_ship = this.fk_ship;

    if (!this.global_id) {
      // Empty strings must be saved as null on database
      this.global_id = undefined;
    }

    body.global_id = this.global_id;

    // CONVERT DESCRIPTION ALL LANGUAGE ====================
    let langTitle: DescLang = new DescLang();
    langTitle.it = this.event_name_it;
    langTitle.en = this.event_name_en;
    langTitle.de = this.event_name_de;
    langTitle.fr = this.event_name_fr;
    langTitle.es = this.event_name_es;
    langTitle.pt = this.event_name_pt;

    let langSH: DescLang = new DescLang();
    langSH.it = this.event_short_description_it;
    langSH.en = this.event_short_description_en;
    langSH.de = this.event_short_description_de;
    langSH.fr = this.event_short_description_fr;
    langSH.es = this.event_short_description_es;
    langSH.pt = this.event_short_description_pt;

    let langLO: DescLang = new DescLang();
    langLO.it = this.event_long_description_it;
    langLO.en = this.event_long_description_en;
    langLO.de = this.event_long_description_de;
    langLO.fr = this.event_long_description_fr;
    langLO.es = this.event_long_description_es;
    langLO.pt = this.event_long_description_pt;

    body.event_name = langTitle;
    body.event_long_description = langLO;
    body.event_short_description = langSH;
    // FINE ==============================================

    // LISTA ATTESA & LOCATION =============================
    // body.event_location = this.event_location;
    body.max_users_wl = this.max_users_wl;
    body.current_users_wl = this.current_users_wl;
    body.waiting_list_end_time = this.waiting_list_end_time!;
    // FINE ================================================

    body.min_age_reservable = this.min_age_reservable ? 18 : 0;
    body.max_per_passenger_reservable = this.max_per_passenger_reservable
      ? environment.constantMaxReservationsPerEvent
      : 100;

    body.time_reservable_before_slot = this.time_reservable_before_slot!;
    body.end_time_reservable_before_slot =
      this.end_time_reservable_before_slot!;

    // ====================================================

    // CONVERSIONE DATI IN ORE/GIORNI =====================================================
    body.time_reservable_before_slot *= selectedTimeTypeApertura.multiplier;
    body.end_time_reservable_before_slot *= selectedTimeTypeChiusura.multiplier;
    body.waiting_list_end_time *= selectedTimeTypeChiusuraWL.multiplier;

    body.end_time_reservable_before_slot *=
      selectedTimeRelativeChiusura.multiplier;
    body.waiting_list_end_time *= selectedTimeRelativeChiusuraWL.multiplier;

    // FINE ============================================================================

    body.event_occurrences = new Array<EventOccurence>();
    this.event_dates?.forEach((date) => {
      let dateFormat: string = moment(date.date).format('YYYY-MM-DD');
      date.event_slots?.forEach((slot) => {
        let occurence: EventOccurence = {
          max_users: slot.max_users!,
          occurrence_end: `${dateFormat}T${slot.end_time}`,
          occurrence_start: `${dateFormat}T${slot.start_time}`,
        };
        if (slot.id_event_slot)
          occurence.id_event_occurrence = slot.id_event_slot;
        if (slot.uuid_event_occurrence)
          occurence.uuid_event_occurrence = slot.uuid_event_occurrence;
        if (slot.detail) {
          occurence.detail = slot.detail;
        }
        body.event_occurrences!.push(occurence);
      });
    });
    delete body.event_dates;
    body.event_groups = this.event_groups;
    body.fk_event_category = this.fk_event_category;
    return body;
  }

  convertToFE(el: any) {
    this.end_time_editable_before_slot = el['end_time_editable_before_slot'];
    this.end_time_reservable_before_slot =
      el['end_time_reservable_before_slot'];
    this.event_groups = el['event_groups'];
    this.event_long_description = el['event_long_description'];
    this.event_short_description = el['event_short_description'];

    const event_name = el['event_name'] || {};
    const esd = el['event_short_description'] || {};
    const eld = el['event_long_description'] || {};
    // CONVERT DESCRIPTION LANGUAGE ======================================
    this.event_name_it = event_name.it;
    this.event_name_en = event_name.en;
    this.event_name_de = event_name.de;
    this.event_name_fr = event_name.fr;
    this.event_name_es = event_name.es;
    this.event_name_pt = event_name.pt;

    this.event_short_description_it = esd.it;
    this.event_short_description_en = esd.en;
    this.event_short_description_de = esd.de;
    this.event_short_description_fr = esd.fr;
    this.event_short_description_es = esd.es;
    this.event_short_description_pt = esd.pt;

    this.event_long_description_it = eld.it;
    this.event_long_description_en = eld.en;
    this.event_long_description_de = eld.de;
    this.event_long_description_fr = eld.fr;
    this.event_long_description_es = eld.es;
    this.event_long_description_pt = eld.pt;
    // FINE ==============================================================

    // LISTA ATTESA, LOCATION ===============================
    // this.event_location = el['event_location'];
    this.max_users_wl = el['max_users_wl'];
    this.current_users_wl = el['current_users_wl'];
    this.waiting_list_end_time = el['waiting_list_end_time'];
    // FINE =================================================
    // this.event_name = el['event_name'];
    this.event_occurrences = el['event_occurrences'];
    this.max_per_passenger_reservable =
      el['max_per_passenger_reservable'] ==
      environment.constantMaxReservationsPerEvent;
    this.min_age_reservable = el['min_age_reservable'] == 18;
    this.time_reservable_before_slot = el['time_reservable_before_slot'];
    this.uuid_event = el['uuid_event'];
    this.id_selector = el['uuid_event'];
    this.name_selector = el['event_name'].en;
    this.fk_event_category = el['fk_event_category'];
    this.fk_ship = el['fk_ship'];
    this.global_id = el['global_id'];
    this.event_opening_mode = el['event_opening_mode'];
    if (el['event_occurrences']) {
      let m = new Map();

      el['event_occurrences'].forEach((element: any) => {
        const startDate = moment(element['start_time'], 'YYYY-MM-DD HH:mm');
        const truncateStartDate = startDate.format('YYYY-MM-DD');
        const endDate = moment(element['end_time'], 'YYYY-MM-DD HH:mm');

        let ed: EventDate = m.get(truncateStartDate);
        if (!ed) {
          ed = new EventDate();
          ed.date = startDate.toDate();
          m.set(truncateStartDate, ed);
        }

        let es = new EventSlot();
        es.start_time = startDate.format('HH:mm');
        es.end_time = endDate.format('HH:mm');
        es.max_users = element['max_users'];
        es.uuid_event_occurrence = element['uuid_event_occurrence'];
        ed.event_slots?.push(es);
        es.detail = element['detail'];
      });

      for (let [_, value] of m) {
        this.event_dates?.push(value);
      }
    }
  }
}

export class MacroEvent {
  id_selector: string;
  name_selector: string;

  constructor(id: string, name: string) {
    this.id_selector = id;
    this.name_selector = name;
  }
}

export class DescLang {
  it?: string | undefined;
  en?: string | undefined;
  de?: string | undefined;
  fr?: string | undefined;
  es?: string | undefined;
  pt?: string | undefined;
}

export class EventOccurence {
  id_event_occurrence?: number;
  occurrence_start!: string;
  occurrence_end!: string;
  max_users!: number;
  uuid_event_occurrence?: string;
  detail?: string;
}

export class EventGroup {
  id_group!: string;
  constructor(id_group: string) {
    this.id_group = id_group;
  }
}

export class EventCategory {
  gcs_icon_url?: string;
  id_event_category!: number;
  name!: string;
  flux!: string;
}

export class Ship{
  id_ship!: string;
  ship_name!: string;
}

export class EventDate {
  date: Date | undefined;
  event_slots: Array<EventSlot> | undefined;
  constructor() {
    this.event_slots = new Array<EventSlot>();
  }
}

export class EventSlot {
  // Es. '08:00'
  start_time: string | null;
  end_time: string | null;
  max_users: number | null;
  id_event_slot?: number;
  uuid_event_occurrence?: string;
  detail?: string;

  constructor(
    start?: string,
    end?: string,
    max?: number,
    slot_id?: number,
    detail?: string
  ) {
    start ? (this.start_time = start) : (this.start_time = null);
    end ? (this.end_time = end) : (this.end_time = null);
    max ? (this.max_users = max) : (this.max_users = null);
    this.id_event_slot = slot_id;
    detail ? (this.detail = detail) : (this.detail = undefined);
  }

  isValid() {
    if (
      !this.end_time ||
      this.end_time[2] != ':' ||
      !this.start_time ||
      this.start_time[2] != ':' ||
      !this.max_users ||
      this.max_users <= 0
    )
      return false;

    let start: number[] = this.start_time.split(':').map((el) => parseInt(el));
    let end: number[] = this.end_time.split(':').map((el) => parseInt(el));

    return !(start[0] > end[0] || (start[0] == end[0] && start[1] >= end[1]));
  }
}

export interface TimeType {
  code: number;
  multiplier: number;
  label: string;
}

export enum OpeningMode {
  FIRST_OCCURRENCE="FIRST_OCCURRENCE",
  EACH_OCCURRENCE="EACH_OCCURRENCE",

}

export namespace OpeningMode {
  export function fromString(value: string): OpeningMode | undefined {
    if (Object.values(OpeningMode).includes(value as OpeningMode)) {
      return value as OpeningMode;
    }
    return undefined;
  }
}
